<label
  #label
  tabindex="0"
  class="checkbox"
  [class.checkbox--checked]="model"
  [class.checkbox--disabled]="disabled"
  (keydown.enter)="doToggle()"
  (keydown.space)="doToggle(); $event.preventDefault()"
>
  <input
    tabindex="-1"
    type="checkbox"
    class="checkbox__native"
    [checked]="model"
    [disabled]="disabled"
    (change)="doToggle()"
  />
  <span class="checkbox__custom" [class.checkbox__custom--error]="error">
    <app-svg-icon class="checkbox__icon" icon="exp-check" width=".875em"></app-svg-icon>
  </span>

  <span class="checkbox__label" [class.checkbox__label--error]="error">
    <ng-content></ng-content>
  </span>
</label>
